import {JSX, useContext} from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../context/AuthProvider";

interface ProtectedRouteProps {
    children: JSX.Element;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
    const authContext = useContext(AuthContext);

    if (authContext?.loading) {
        return <div>Loading...</div>; // Bisa diganti dengan skeleton UI atau spinner
    }

    if (!authContext?.user) {
        return <Navigate to="/login" replace />;
    }

    return children;
};

export default ProtectedRoute;
